export class ReconnectSourceAccountResponse {
    'sourceAccount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceAccount",
            "baseName": "sourceAccount",
            "type": "SourceAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ReconnectSourceAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
